import googleMapsApiLoader from 'google-maps-api-loader';

function init() {

	const $place = $('.place-single');
	const lat = $('#place-single__map-canvas').data('lat');
	const lng = $('#place-single__map-canvas').data('lng');

	if (!$place.length || !lat || !lng) {
		return;
	}

	googleMapsApiLoader({
		libraries: ['places'],
		apiKey: 'AIzaSyAgYWo4_VL_oAbM0ARvq6rStRUN1deK7R0'
	}).then((googleApi) => {

		const map = new googleApi.maps.Map(document.getElementById('place-single__map-canvas'), {
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: false,
			draggable: false,
			scrollwheel: false
		});

		const marker = new googleApi.maps.Marker();

		marker.setPosition({
			lat,
			lng
		});

		marker.setMap(map);
		map.setCenter(marker.getPosition());
		map.setZoom(14);

	});

}

export default {
	init
};
